import { styled, css } from 'styled-components';
import { BREAKPOINTS } from '../../constants/layout.mjs';
import { theme } from '../../constants/theme.mjs';
import '../StyleableSvgImage/index.mjs';
import { StyleableSvgImage } from '../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const FADE_BUTTON_SIZE = 40;
const ScrollContainer = styled.div`
  /* Inherit all - items defined below will overwrite inherited */
  all: inherit;
  display: flex;

  ${({
  $gap
}) => css`
    gap: ${$gap}px;
  `}

  ${({
  $direction
}) => {
  switch ($direction) {
    case "horizontal":
      return css`
          overscroll-behavior-x: contain;
          overflow: scroll hidden;
          flex-direction: row;
        `;
    case "vertical":
      return css`
          overscroll-behavior-y: contain;
          overflow: hidden scroll;
          flex-direction: column;
        `;
  }
}};

  /* Hide scroll bar */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Item = styled.div`
  flex-shrink: 0;

  ${({
  $draggable
}) => $draggable && css`
      &,
      * {
        user-select: none;
        -webkit-user-drag: none;
      }
    `}
`;
const ArrowIcon = styled.div`
  z-index: 10;
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  max-height: 100%;
  transition: opacity 0.2s ease-in-out;
  opacity: ${({
  $show
}) => $show ? "1" : "0"};

  ${({
  $show
}) => !$show && css`
      pointer-events: none;
    `}

  ${({
  $fillType,
  $direction,
  $accentColor
}) => $accentColor && $fillType === "solid" && ($direction === "horizontal" ? css`
          border-left: 1px solid ${$accentColor};
        ` : css`
          border-top: 1px solid ${$accentColor};
        `)}

  ${({
  $direction,
  $first,
  $arrowGap
}) => {
  switch ($direction) {
    case "horizontal":
      {
        return $first ? css`
              width: ${FADE_BUTTON_SIZE}px;
              height: 100%;
              left: ${$arrowGap ? `${$arrowGap}px` : 0};
              top: 50%;
              transform: translateY(-50%) rotate(180deg);

              @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
                left: ${$arrowGap ? `10px` : 0};
              }
            ` : css`
              width: ${FADE_BUTTON_SIZE}px;
              height: 100%;
              right: ${$arrowGap ? `${$arrowGap}px` : 0};
              top: 50%;
              transform: translateY(-50%);

              @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
                right: ${$arrowGap ? `10px` : 0};
                width: 30px;
              }
            `;
      }
    case "vertical":
      {
        return $first ? css`
              width: 100%;
              height: ${FADE_BUTTON_SIZE}px;
              top: ${$arrowGap ? `${$arrowGap}px` : 0};
              left: 50%;
              transform: translateX(-50%) rotate(-90deg);
            ` : css`
              width: 100%;
              height: ${FADE_BUTTON_SIZE}px;
              bottom: ${$arrowGap ? `${$arrowGap}px` : 0};
              left: 50%;
              transform: translateX(-50%) rotate(90deg);
            `;
      }
  }
}}

  ${({
  $arrowFadeColor
}) => $arrowFadeColor && css`
      &::before {
        content: "";
        position: absolute;
        inset: -1px 0;
        background: linear-gradient(
          90deg,
          transparent 0%,
          ${$arrowFadeColor} 40%
        );
        z-index: -1;
      }
    `}

  ${({
  $circleArrowBackground
}) => $circleArrowBackground && css`
      height: 60px;
      width: 60px;
      border-radius: 50%;
      background: rgb(0 0 0 / 0.1);
      transition: background 0.2s;

      @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
        height: 40px;
        width: 40px;
      }

      &:hover {
        background: rgb(0 0 0 / 0.15);
      }

      ${ArrowIconSvg} {
        color: ${theme.colors.menu.base.light};
      }
    `}

  > svg {
    width: 8px;
    height: auto;
  }
`;
const RightArrowIcon = styled(ArrowIcon)``;
const LeftArrowIcon = styled(ArrowIcon)``;
const OuterContainer = styled.div`
  /* Inherit all - items defined below will overwrite inherited */
  all: inherit;

  position: relative;
  padding: 0;

  ${({
  $align,
  $direction
}) => {
  switch ($align) {
    case "left":
      return $direction === "horizontal" ? css`
              justify-content: flex-start;
            ` : css`
              align-items: flex-start;
            `;
    case "center":
      return $direction === "horizontal" ? css`
              justify-content: center;
            ` : css`
              align-items: center;
            `;
    case "right":
      return $direction === "horizontal" ? css`
              justify-content: flex-end;
            ` : css`
              align-items: flex-end;
            `;
  }
}};

  ${({
  $direction,
  $showFadeStart,
  $showFadeEnd
}) => {
  if (!$showFadeStart && !$showFadeEnd) {
    return;
  }
  switch ($direction) {
    case "horizontal":
      return css`
          justify-content: flex-start;
        `;
    case "vertical":
      return css`
          align-items: flex-start;
        `;
  }
}};

  /* Case for solid fill */
  ${({
  $fillType,
  $fillColor,
  $showFadeStart,
  $showFadeEnd,
  $gradientSize
}) => {
  const fillColor = $fillColor ?? theme.colors.white;
  switch ($fillType) {
    case "gradient":
      return css`
          &::after,
          &::before {
            content: "";
            height: 100%;
            width: ${$gradientSize ? `${$gradientSize}px` : "80px"};
            position: absolute;
            z-index: 1;
            pointer-events: none;
            transition: opacity 0.2s ease-in-out;

            /* TODO based on $direction */
            top: 0;
          }

          &::before {
            /* TODO based on $direction */
            left: -1px;
            opacity: ${$showFadeStart ? "1" : "0"};
            background: linear-gradient(
              to right,
              ${fillColor} 20%,
              rgb(0 0 0 / 0) 100%
            );
          }

          &::after {
            /* TODO based on $direction */
            right: -1px;
            opacity: ${$showFadeEnd ? "1" : "0"};
            background: linear-gradient(
              to left,
              ${fillColor} 20%,
              rgb(0 0 0 / 0) 100%
            );
          }
        `;
    case "solid":
      return css`
          ${ArrowIcon} {
            background: ${fillColor};
          }
        `;
    default:
      return;
  }
}}
`;
const ArrowIconSvg = styled(StyleableSvgImage)`
  color: ${({
  $arrowColor
}) => $arrowColor ?? "#909090"};
`;
export { ArrowIcon, ArrowIconSvg, FADE_BUTTON_SIZE, Item, LeftArrowIcon, OuterContainer, RightArrowIcon, ScrollContainer };
//# sourceMappingURL=ScrollWrapper.styles.mjs.map
